module.exports = __webpack_public_path__ + "img/松本健太郎.0c0ecc93.jpg";